import { ActionTypes, TypeKeys } from '../actions';

const getInitialState = (): MusicPlayerState => {
  return {
    stationName: null,
    songName: null,
    songProgress: 0,
    isPlaying: false,
    feedFMstations: [],
    activeStationId: null,
    musicInitialized: false,
    artistName: null,
    albumName: null,
    musicPlaylists: [],
    showMusicPlayer: false,
    shouldStopMusicAfterSong: false,
    loadingStationId: null,
  };
};

const musicPlayerState = (
  state = getInitialState(),
  action: ActionTypes
): MusicPlayerState => {
  switch (action.type) {
    case TypeKeys.MUSIC_INIT: {
      return {
        ...state,
        musicInitialized: true,
      };
    }
    case TypeKeys.LOAD_WORKOUT: {
      return {
        ...state,
        shouldStopMusicAfterSong: false,
      };
    }
    case TypeKeys.END_WORKOUT: {
      return {
        ...state,
        shouldStopMusicAfterSong: true,
      };
    }
    case TypeKeys.MUSIC_STOP: {
      return {
        ...state,
        musicInitialized: false,
        showMusicPlayer: false,
      };
    }
    case TypeKeys.MUSIC_CHANGE_STATION: {
      return {
        ...state,
        loadingStationId: action.stationId,
      };
    }
    case TypeKeys.MUSIC_UPDATE_STATE: {
      return {
        ...state,
        ...action.musicPlayerState,
      };
    }
    case TypeKeys.MUSIC_PAUSE: {
      return {
        ...state,
        isPlaying: false,
      };
    }
    case TypeKeys.MUSIC_PLAY: {
      return {
        ...state,
        isPlaying: true,
        showMusicPlayer: true,
      };
    }
    case TypeKeys.MUSIC_SET_FEEDFM_STATIONS: {
      return {
        ...state,
        feedFMstations: action.stations,
      };
    }
    case TypeKeys.SET_MUSIC_PLAYLISTS: {
      return {
        ...state,
        musicPlaylists: action.musicPlaylists,
      };
    }
  }
  return state;
};

export default musicPlayerState;
